import { ApiResponse } from '../types/api';
import { tokenApi } from './base';

const postValidateHmac = tokenApi.injectEndpoints({
  endpoints: (builder) => ({
    postValidateHmac: builder.mutation<
      boolean,
      {
        payload: string;
        signature: string;
      }
    >({
      query: (body) => ({
        url: '/validate-hmac',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostValidateHmacMutation } = postValidateHmac;
